export enum DecisionEnum {
	ACCEPT,
	REJECT
}
